<template>
  <v-row>
    <v-col cols="8">
      <div class="d-flex justify-space-between">
        <h1 class="titleSt">Componente Múltiplas Fotos Simples</h1>
        <a class="text-decoration-none">
          <v-btn class="text-white" color="grey" @click="$emit('close-modal')">Cancelar</v-btn>
          <v-btn class="text-white" color="#ff5000" @click="store" v-bind:disabled="btn_disabled">Salvar</v-btn>
        </a>
      </div>
      <div class="mainInputs">
        <v-text-field v-model="fragmentId" label="ID do componente" hide-details="auto" @keyup="onInputChange()"></v-text-field>
      </div>
      <div class="mainInputs">
        <v-text-field v-model="title" label="Título" :rules="rules" hide-details="auto" @keyup="onInputChange()"></v-text-field>
      </div>

      <div>
        <hr />
        <h2>Fotos</h2>
        <div>
          <div v-for="item in photoItems" :key="item.id" class="mainInputs">
            <div class="d-flex justify-space-between align-center mb-2">
              <h3>Foto {{ item.id }}</h3>
              <v-btn v-if="item.id != 1" color="red" size="small" @click="removePhotoItem(item.id)">
                <v-icon>mdi-delete</v-icon>
                Remover
              </v-btn>
            </div>

            <v-text-field v-model="item.fragmentPhotoItemId" label="ID do item da foto" hide-details="auto" @keyup="onInputChange()"></v-text-field>
            <v-text-field v-model="item.title" label="Título" :rules="rules" hide-details="auto" @keyup="onInputChange()"></v-text-field>
            <v-text-field v-model="item.description" label="Descrição" :rules="rules" hide-details="auto" @keyup="onInputChange()"></v-text-field>

            <v-text-field v-model="item.imageUrl" label="URL da imagem" :rules="rules" hide-details="auto" @keyup="onInputChange()">
              <template v-slot:prepend-inner>
                <v-icon>mdi-link</v-icon>
              </template>
            </v-text-field>
            <v-switch v-model="item.requirePhoto" :color="movida_color" @change="verifyBtnDisabled()" :label="'Foto obrigatória? ' + (item.requirePhoto ? 'Sim' : 'Não')"></v-switch>
          </div>
          <v-btn @click="addPhotoItem" color="primary" class="mt-2">
            <v-icon>mdi-plus</v-icon>
            Adicionar foto
          </v-btn>
        </div>
      </div>
    </v-col>

    <v-col cols="4">
      <custom-img-component :imageSrc="imageSrc" />
    </v-col>
  </v-row>

  <v-snackbar v-model="snackbar" :timeout="timeout">
    <v-icon class="ml-1"> mdi-information-outline </v-icon> {{ text }}
    <template v-slot:actions>
      <v-btn variant="text" @click="closeSnack"> Fechar </v-btn>
    </template>
  </v-snackbar>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import messages from "@/constants/messages";
import CustomImgComponent from "@/components/CustomImg/CustomImgComponent.vue";

@Options({
  components: {
    CustomImgComponent,
  },
})
export default class MultiplePhotoSimpleComponent extends Vue {
  public rules = [(value: any) => !!value || "Required.", (value: string) => (value && value.length >= 3) || "Min 3 characters"];
  public title = "";
  public fragmentId = "";
  public photoItems: Array<{
    id: number;
    fragmentPhotoItemId: string;
    title: string;
    description: string;
    imageUrl: string;
    requirePhoto: boolean;
  }> = [
    {
      id: 1,
      fragmentPhotoItemId: "",
      title: "",
      description: "",
      imageUrl: "",
      requirePhoto: false,
    },
  ];
  public nextItemId = 2;
  public typeFragment = "CustomMultiplePhotoSimpleFragment";
  public messages: any = {};
  public isLoadingTable = true;
  public needleSearch: any;
  public snackbar = false;
  public text = "";
  public timeout = 10000;
  public btn_disabled = true;
  public generatedJson: any;
  public form: any;
  public movida_color = "#ff5000";
  // public imageSrc = require("@/assets/CustomComponentsImgExamples/MultiplePhotoSimple.png");

  mounted(): void {
    this.messages = messages;
    this.$emit("mounted", this);

    // Verificar o maior ID em this.photoItems e ajusta nextItemId
    if (this.photoItems && this.photoItems.length > 0) {
      const maxId = Math.max(...this.photoItems.map((item) => item.id));
      if (maxId > 1) {
        this.nextItemId = maxId + 1;
      }
    }
  }

  changeLoading(): void {
    this.isLoadingTable = !this.isLoadingTable;
  }

  closeSnack(): void {
    this.snackbar = false;
  }

  onInputChange() {
    this.btn_disabled = true;
    this.verifyBtnDisabled();
  }

  verifyBtnDisabled() {
    if (this.title?.length >= 3 && this.photoItems.every((item) => item.title?.length >= 3 && item.description?.length >= 3 && item.imageUrl?.length > 0)) {
      this.btn_disabled = false;
    }
    return this.btn_disabled;
  }

  addPhotoItem() {
    this.photoItems.push({
      id: this.nextItemId,
      fragmentPhotoItemId: "",
      title: "",
      description: "",
      imageUrl: "",
      requirePhoto: false,
    });
    this.nextItemId++;
    this.btn_disabled = true;
  }

  removePhotoItem(id: number) {
    const index = this.photoItems.findIndex((item) => item.id === id);
    if (index !== -1) {
      this.photoItems.splice(index, 1);
      this.verifyBtnDisabled();
    }
  }

  public updateAttributes(data: any) {
    this.title = data.title;
    this.fragmentId = data.fragmentId || "";
    this.photoItems.splice(0, 1);
    let nextItemId = 1;

    if (data.photoList && Array.isArray(data.photoList)) {
      data.photoList.forEach((photo: any) => {
        this.photoItems.push({
          id: nextItemId,
          fragmentPhotoItemId: photo.fragmentPhotoItemId || "",
          title: photo.title,
          description: photo.description,
          imageUrl: photo.imageUrl || "",
          requirePhoto: photo.requirePhoto || false,
        });
        nextItemId++;
      });
    }
  }

  async convertToJson(): Promise<void> {
    this.verifyBtnDisabled();
    if (this.typeFragment && !this.btn_disabled) {
      try {
        const photoList = [];

        for (const item of this.photoItems) {
          photoList.push({
            title: item.title,
            fragmentPhotoItemId: item.fragmentPhotoItemId,
            description: item.description,
            imageUrl: item.imageUrl,
            requirePhoto: item.requirePhoto,
          });
        }

        const json = {
          title: this.title,
          fragmentId: this.fragmentId,
          typeFragment: this.typeFragment,
          photoList: photoList,
          hidden_component_id: 20, // 20 é componente MÚLTIPLAS FOTOS SIMPLES
        };

        this.generatedJson = json as any;
        return this.generatedJson;
      } catch (error) {
        console.error("Erro na conversão para JSON (multiple photos simple)", error);
      }
    }
  }

  async store(): Promise<void> {
    try {
      const jsonPromise = this.convertToJson();
      const json = await jsonPromise;
      const success_error_msg = "Dados gravados";
      const data = {
        success_error_msg: success_error_msg,
        json: json,
      };

      this.$emit("generatedJson", data);
      this.$emit("close-modal");
    } catch (error) {
      const successErrorMsg = "Erro ao tentar gravar os dados";
      console.log("Erro ao gravar os dados (multiple photos simple)", error);
    }
  }
}
</script>

<style lang="css">
.default-data-base {
  border: solid #efecec 0.4px;
}

.w-3 {
  width: 10px;
}

.h-3 {
  height: 10px;
}

.mainInputs:not(:last-child) {
  margin-bottom: 15px;
}

.hiddenInput {
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
  pointer-events: none;
}

.newFileInput {
  height: 60px;
}

.fileErrorColorBlack {
  color: black;
  opacity: 0.8;
  pointer-events: none;
}

.fileErrorRed .v-label {
  color: #b00020;
  opacity: 1;
  pointer-events: none;
}

.fileErrorIconBlack {
  color: black;
}

.fileErrorIconRed {
  opacity: 1;
  color: #b00020;
}

.fileErrorMsg {
  font-size: 0.75rem;
  color: #b00020;
  margin-left: 16px;
}

.titleSt {
  margin-right: 200px;
}
</style>
